import RequestMethod from "@/models/client/RequestMethod";
import RestResponse from "@/models/client/RestResponse";
import { ReleaseNoteResponse } from "@/models/release-notes/ReleaseNote";
import { RestClient } from "./restClient";

// Read-only: release notes are authored via Swagger (ManageReleaseNotes), not the UI.
export type ReleaseNoteServiceType = {
  getAll: () => RestResponse<ReleaseNoteResponse[]>;
  getById: (id: string) => RestResponse<ReleaseNoteResponse>;
};

const releaseNoteService = (
  client: RestClient,
  path: string
): ReleaseNoteServiceType => ({
  getAll: async () =>
    await client.fetch<ReleaseNoteResponse[]>(RequestMethod.GET, path),

  getById: async (id: string) =>
    await client.fetch<ReleaseNoteResponse>(RequestMethod.GET, `${path}/${id}`),
});

export default releaseNoteService;
